import { JOB_STATUS } from '../constants'
import { Stop } from '../interfaces'

export const STATUS_TEXT = {
    collected: 'Collected',
    arrivedAt: 'Arrived At',
    delivered: 'Delivered',
    accepted: 'Accepted',
}

export const useJobStatusText = (jobStatus?: string, stops?: Stop[]) => {
    switch (jobStatus) {
        case JOB_STATUS.pickup:
            return STATUS_TEXT.collected
        case JOB_STATUS.arrivedAt:
            if (stops?.[1]?.stopStatus !== JOB_STATUS.completed) {
                return STATUS_TEXT.arrivedAt
            }
            return jobStatus
        case JOB_STATUS.deliver:
            return STATUS_TEXT.delivered
        case JOB_STATUS.accept:
            return STATUS_TEXT.accepted
        default:
            return jobStatus
    }
}
